'use client';

import { useEffect } from 'react';

import { markWebviewBootHealthy } from './webview-boot-health';

/**
 * Sinaliza boot saudável assim que o React client monta.
 * O watchdog em `public/webview-boot-watchdog.js` só sugere atualizar
 * o WebView se este sinal não chegar a tempo (tipicamente Android).
 */
export const WebviewBootHealthGuard: React.FC = () => {
  useEffect(() => {
    markWebviewBootHealthy();
  }, []);

  return null;
};
